import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'

const BottomSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const Button = styled.button`
  background-color: ${colors.uguBrightPurple};
  height: 51px;
  line-height: 51px;
  padding: 0px 1rem;
  cursor: pointer;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    background-color: ${colors.uguBrightBlue};
  }

  /* Next Step */
  border-radius: 10px;
  font-family: var(--font-inter);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;

  color: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  :disabled {
    opacity: 0.6;
    cursor: default;
    background-color: ${colors.uguBrightPurple};
  }
`
const CourseAmountButton = styled.div<{
  width: string
}>`
  width: ${(props) => props.width};
  /* padding: 0px 30px; */
  height: 40px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid
    ${(props) => (props.active ? colors.uguBrightPurple : colors.uguGray)};
  font-family: ${fontFamilies.regular};
  cursor: pointer;
  :hover {
    border: 2px solid
      ${(props) => (props.active ? colors.uguBrightPurple : colors.uguDarkGrey)};
  }
`
const BackButton = styled.div`
  background-color: white;
  width: 120px;
  height: 51px;
  line-height: 51px;
  cursor: pointer;
  transition: 0.2s;
  :hover {
    background-color: ${colors.uguGray};
  }

  /* Next Step */
  border-radius: 10px;
  font-family: var(--font-inter);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  border: 1px solid ${colors.uguDarkGrey};
  align-items: center;
  display: flex;
  justify-content: center;
  color: ${colors.uguPurple};
  flex: none;
  order: 0;
  flex-grow: 0;
`
const TitleSection = styled.div`
  text-align: center;
  font-family: var(--font-inter);
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: ${colors.uguPurple};
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 0px auto;
`
const DropdownButton = styled.button`
  display: flex;
  border: 2px solid ${colors.uguGray};
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  padding: 0px 1rem;
  font-family: var(--font-inter);
  font-size: 15px;
  :active {
    border: 2px solid black;
  }
`

export {
  CourseAmountButton,
  Button,
  BottomSection,
  BackButton,
  TitleSection,
  DropdownButton,
}
